import HomeSkeleton from './pages/home-activity/HomeSkeleton'

// Tech Spec: https://www.notion.so/daangn/Tech-Spec-Webview-Entry-Loading-FCP-48afd5f704d347a991be56b48be74df1
const AppLoading = () => {
  const url = new URL(window.location.href)

  switch (url.pathname) {
    case '/':
    case '/home':
    case '/home/':
      return <HomeSkeleton />
  }

  return null
}

export default AppLoading
